export default __webpack_public_path__ + "static/media/sd.18c787c0.svg";